const COLLECT_JS_SCRIPT_ID = "nmi-collect-js";
const DEFAULT_COLLECT_JS_URL = "https://secure.nmi.com/token/Collect.js";

export const getNmiTokenizationKey = () =>
  process.env.REACT_APP_NMI_PUBLIC_TOKENIZATION_KEY || "";

export const loadCollectJs = ({
  tokenizationKey = getNmiTokenizationKey(),
  collectJsUrl,
} = {}) => {

  if (!tokenizationKey) {
    return Promise.reject(new Error("NMI tokenization key is not configured"));
  }

  if (window.CollectJS) {
    return Promise.resolve(window.CollectJS);
  }

  const existingScript = document.getElementById(COLLECT_JS_SCRIPT_ID);
  if (existingScript) {
    return new Promise((resolve, reject) => {
      existingScript.addEventListener("load", () => resolve(window.CollectJS));
      existingScript.addEventListener("error", reject);
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.id = COLLECT_JS_SCRIPT_ID;
    script.src =
      collectJsUrl ||
      process.env.REACT_APP_NMI_COLLECT_JS_URL ||
      DEFAULT_COLLECT_JS_URL;
    script.async = true;
    script.setAttribute("data-tokenization-key", tokenizationKey);
    script.setAttribute("data-variant", "inline");
    script.onload = () => resolve(window.CollectJS);
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

export const getCardMetadataFromTokenResponse = (response = {}) => {
  const card = response.card || {};
  const exp = card.exp || "";
  const expMonth = exp.slice(0, 2);
  const expYearValue = exp.slice(2);
  const expYear =
    expYearValue.length === 2 ? `20${expYearValue}` : expYearValue;
  const digits = (card.number || "").replace(/\D/g, "");

  return {
    paymentToken: response.token || response.payment_token,
    cardType: card.type,
    cardHash: card.hash,
    expMonth,
    expYear,
    last4: digits.slice(-4),
  };
};
